import { useState } from 'react';
import { Box, Button, Dialog, Typography } from '@mui/material';
import CommonModal from '@/components/CommonModal';
import { ConfettiIcon, RightChevron } from '@/icons/svgIcons';
import { useTranslation } from '@/hooks/translations';
import { useTutorial } from '../../contexts';

const NavBarActionButton = () => {
    const { t } = useTranslation('common');
    const { list, open } = useTutorial();
    const [openModal, setOpenModal] = useState(false);

    if (list.length === 0) {
        return null;
    }

    return (
        <>
            <Button
                variant="outlined"
                sx={{ backgroundColor: '#7D00D414', borderWidth: 0, borderRadius: '8px', width: '100%' }}
                onClick={() => setOpenModal(true)}
            >
                <ConfettiIcon />
                <Typography variant="body2" sx={{ marginLeft: 1 }}>
                    {t(`What's new`)}
                </Typography>
            </Button>
            <Dialog
                open={openModal}
                onClose={() => setOpenModal(false)}
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        p: 0,
                        minWidth: 400,
                        boxShadow: 8,
                    },
                }}
            >
                <CommonModal onClose={() => setOpenModal(false)} title={"What's new"}>
                    <Box sx={{ p: 2, pt: 0, borderTop: '1px solid', borderColor: 'grey.200' }}>
                        {list.map((item) => (
                            <Box key={item.id} sx={{ borderBottom: '1px solid', borderColor: 'grey.200' }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        py: 2,
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => open(item.id)}
                                >
                                    <Box>
                                        <Box sx={{ fontWeight: 400, fontSize: 17, mb: 0.5 }}>{item.namespace}</Box>
                                    </Box>
                                    <Box sx={{ color: 'grey.500', ml: 2 }}>
                                        <RightChevron />
                                    </Box>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </CommonModal>
            </Dialog>
        </>
    );
};

export default NavBarActionButton;
